import React from 'react';

function SeatChangeInput({ numberOfSeats, disabled, onChange, setShowUpgradeMessage, maxSeats = 50, minSeats = 0 }) {

    function incrementSeats() {
        const newValue = numberOfSeats + 1;
        if (newValue <= maxSeats) {
            onChange(numberOfSeats + 1);
        }
        setShowUpgradeMessage(newValue > maxSeats);
    }

    function decrementSeats() {
        const newValue = numberOfSeats - 1;
        if (newValue >= minSeats) {
            onChange(numberOfSeats - 1);
        }
        setShowUpgradeMessage(newValue > maxSeats);
    }

    function handleChange(e) {
        const { value } = e.target;
        const numValue = Number(value);
        if (
            typeof numValue === "number" &&
            numValue % 1 === 0
        ) {
            onChange(numValue);
        }
    }

    function handleBlur(e) {
        if (numberOfSeats >= maxSeats) {
            onChange(maxSeats);
        } else if (numberOfSeats <= minSeats) {
            onChange(minSeats);
        }
        setShowUpgradeMessage(numberOfSeats > maxSeats);
    }

    return (
        <div className='d-flex align-items-center'>
            <button
                aria-label='decrement seats'
                disabled={disabled || numberOfSeats <= minSeats}
                onClick={decrementSeats}
                style={{
                    backgroundColor: (disabled || numberOfSeats <= minSeats) ? "#dee4ec" : "#1678f2",
                    color: "#fff", borderRadius: '100%', border: "none", height: "24px", width: "24px", lineHeight: "0"
                }}
            >
                <span style={{ fontSize: '22px'}}>
                    -
                </span>
            </button>
            <input
                aria-label='Number of Seats'
                style={{ width: "50px", height: "32px" }}
                disabled={disabled}
                id='num-seats-input'
                className="d-inline-block rounded mx-2 pt-1 text-center"
                onChange={handleChange}
                onBlur={handleBlur}
                value={numberOfSeats} />
            <button
                aria-label='increment seats'
                disabled={disabled || numberOfSeats >= maxSeats}
                onClick={incrementSeats}
                style={{
                    backgroundColor: (disabled || numberOfSeats >= maxSeats) ? "#dee4ec" : "#1678f2",
                    color: "#fff", borderRadius: '100%', border: "none", height: "24px", width: "24px", lineHeight: "0"
                }}
            >
                <span style={{ fontSize: '22px'}}>
                    +
                </span>
            </button>
            <span className='ms-3 font-size-0 font-weight'>Seats</span>
        </div>
    )
}

export default SeatChangeInput;